export default /* css */ `
:host {
  --ui-icon-button-icon-size: calc(var(--ui-sys-unit) * 24);
  --ui-icon-button-icon-opacity: 1;
  --ui-icon-button-icon-color: var(--ui-sys-color-on-surface-variant);

  --ui-icon-button-container-opacity: 1;
  --ui-icon-button-container-height: calc(var(--ui-sys-unit) * 40);
  --ui-icon-button-container-width: calc(var(--ui-sys-unit) * 40);
  --ui-icon-button-container-width: var(--ui-icon-button-container-height);
  --ui-icon-button-container-shape: var(--ui-sys-shape-corner-full);

  --ui-icon-button-outline-width: calc(var(--ui-sys-unit) * 1);
  --ui-icon-button-outline-color: var(--ui-sys-color-outline);

  --button-focus-ring-indicator-color: var(--ui-button-focus-ring-indicator-color, var(--ui-sys-color-secondary));
  --button-focus-ring-indicator-thickness: var(--ui-button-focus-ring-indicator-thickness, var(--ui-sys-state-focus-indicator-thickness));
  --button-focus-ring-outline-offset: var(--ui-button-focus-ring-outline-offset, var(--ui-sys-state-focus-indicator-outer-offset));
}

::slotted(ui-icon) {
  --ui-icon-color: var(--ui-icon-button-icon-color);
  --ui-icon-opacity: var(--ui-icon-button-icon-opacity);
}

ui-base-button {
  --ui-button-container-shape: var(--ui-icon-button-container-shape);
  --ui-button-container-width: var(--ui-icon-button-container-width);
  --ui-button-container-height: var(--ui-icon-button-container-height);
  --ui-button-container-padding-top: 0;
  --ui-button-container-padding-right: 0;
  --ui-button-container-padding-bottom: 0;
  --ui-button-container-padding-left: 0;
}

.ui-icon-button--variant-filled {
  --ui-icon-button-container-color: var(--ui-sys-color-primary);
  --ui-icon-button-icon-color: var(--ui-sys-color-on-primary);
  --ui-ripple-pressed-color: hsl(var(--ui-sys-color-on-primary));

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-opacity: var(
        --ui-sys-state-hover-state-layer-opacity
      );
      --ui-sys-state-layer-color: var(--ui-sys-color-on-surface);
    }
  }

  &.ui-icon-button--is-disabled {
    --ui-icon-button-container-color: var(--ui-sys-color-on-surface);
    --ui-icon-button-icon-color: var(--ui-sys-color-on-surface);
  }
}

.ui-icon-button--variant-tonal {
  --ui-icon-button-container-color: var(--ui-sys-color-secondary-container);
  --ui-icon-button-icon-color: var(--ui-sys-color-on-secondary-container);
  --ui-ripple-pressed-color: hsl(var(--ui-sys-color-on-secondary-container));

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-opacity: var(
        --ui-sys-state-hover-state-layer-opacity
      );
      --ui-sys-state-layer-color: var(--ui-sys-color-on-secondary-container);
    }
  }

  &.ui-icon-button--is-disabled {
    --ui-icon-button-container-color: var(--ui-sys-color-on-surface);
    --ui-icon-button-icon-color: var(--ui-sys-color-on-surface);
  }
}

.ui-icon-button--variant-outlined {
  --ui-icon-button-icon-color: var(--ui-sys-color-on-surface-variant);
  --ui-ripple-pressed-color: hsl(var(--ui-sys-color-primary));

  border: var(--ui-icon-button-outline-width) solid
    hsla(
      var(--ui-icon-button-outline-color),
      var(--ui-icon-button-container-opacity)
    );

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-opacity: var(
        --ui-sys-state-hover-state-layer-opacity
      );
      --ui-sys-state-layer-color: var(--ui-sys-color-primary);
    }
  }

  &.ui-icon-button--is-disabled {
    --ui-icon-button-icon-color: var(--ui-sys-color-on-surface);
    --ui-icon-outline-color: var(--ui-sys-color-on-surface);
  }
}

.ui-icon-button--variant-standard {
  --ui-ripple-pressed-color: hsl(var(--ui-sys-color-primary));
  --ui-icon-button-container-color: transparent;
  --ui-icon-button-icon-color: var(--ui-sys-color-on-surface-variant);

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-opacity: var(
        --ui-sys-state-hover-state-layer-opacity
      );
      --ui-sys-state-layer-color: var(--ui-sys-color-on-surface);
    }
  }

  &.ui-icon-button--is-disabled {
    --ui-icon-button-icon-color: var(--ui-sys-color-on-surface);
  }
}

.ui-icon-button--is-disabled {
  --ui-icon-button-container-opacity: 0.12;
  --ui-icon-button-icon-opacity: 0.38;

  cursor: unset;

  &.ui-sys-state-layer:before {
    display: none;
  }
}
`
